// extracted by mini-css-extract-plugin
export default {"top":"top___w0pUW"};